import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AuthService } from "./auth.service";
import { take, map } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class AuthguardService implements CanActivate {
  canActivate(
    route: import("@angular/router").ActivatedRouteSnapshot,
    state: import("@angular/router").RouterStateSnapshot
  ):
    | boolean
    | import("@angular/router").UrlTree
    | import("rxjs").Observable<boolean | import("@angular/router").UrlTree>
    | Promise<boolean | import("@angular/router").UrlTree> {
    return this.authService.authDataSubject.pipe(
      take(1),
      map(usersRes => {
        const isAuth = !!usersRes;
        console.log(isAuth + "isAuth" + usersRes);

        if (isAuth) {
          return true;
        } else {
          this.router.navigate(["/auth"]);
        }
      })
    );
  }

  constructor(private authService: AuthService, private router: Router) {}
}
